import { Section } from '../layout/Section';
import { SectionHeader } from '../layout/SectionHeader';
import { Accordion } from '../ui/Accordion';
import { Button } from '../ui/Button';
import { faqs } from '../../data/pages';

/**
 * Landing shows the first four; /faqs shows the full set. On the standalone page
 * this heading is the document's h1, so `as` is caller-controlled.
 */
export function Faq({ limit = 4, showViewAll = true, headingLevel = 'h2' }) {
  const items = limit ? faqs.items.slice(0, limit) : faqs.items;

  return (
    <Section id="faq">
      <SectionHeader as={headingLevel} eyebrow={faqs.eyebrow} title={faqs.title} subtitle={faqs.subtitle} />
      <Accordion items={items} defaultOpen={1} />

      {showViewAll && (
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: 'var(--space-8)' }}>
          <Button to="/faqs" icon="arrow-right-circle">
            View all
          </Button>
        </div>
      )}
    </Section>
  );
}
